// Open a form with specific data
export function openForm(
  formId,
  className,
  fieldData = {},
  fullBookingLinkId = null,
  bookingId = null,
  bookingStatus = null,
) {
  // Set booking link to FULL BOOKING button
  if (fullBookingLinkId && bookingId) {
    let fullBookingLink = document.getElementById(fullBookingLinkId);
    let newUrl = `/fullbooking/${bookingId}/`;
    fullBookingLink.setAttribute('href', newUrl);
    //Add status classes to FULL BOOKING button
    if (bookingStatus) {
      // Remove any class that contains 'status'
      const classesToRemove = Array.from(fullBookingLink.classList).filter(
        (className) => className.includes('status'),
      );
      classesToRemove.forEach((className) =>
        fullBookingLink.classList.remove(className),
      );

      let classesToAdd = bookingStatus.split(' ');
      fullBookingLink.classList.add(...classesToAdd);
    }
  }

  // Add duration to fieldData if it is defined
  if (fieldData.duration_nights !== null) {
    let durationElement = document.querySelector(`#${formId} .duration_nights`);
    if (durationElement) {
      fieldData.duration = fieldData.duration_nights;
    }
  } else if (fieldData.duration_days !== null) {
    let durationElement = document.querySelector(`#${formId} .duration_days`);
    if (durationElement) {
      fieldData.duration = fieldData.duration_days;
    }
  }
  // Activate backdrop
  document.getElementById('backdrop').style.display = 'block';

  document.getElementById(formId).classList.add(className);
  fillFormFields(formId, fieldData);
}

// Fill form fields function
function fillFormFields(formId, fields) {
  Object.keys(fields).forEach((key) => {
    const formElement = document.querySelector(`#${formId} [name="${key}"]`);
    if (formElement) {
      formElement.value = fields[key];
    }
  });
}
